import './Separator.css'
const Separator = ({first, second, third}) => {
    return (
        <div className={"h-separator animate"}>
            <img className={"sep-icon "} src={first} alt={"corn, mais, katsaka agri-tech solution madagascar"}/>
            <img className={"sep-icon "} src={second} alt={"corn, mais, katsaka agri-tech solution madagascar"}/>
            <img className={"sep-icon"} src={third} alt={"corn, mais, katsaka agri-tech solution madagascar"}/>
        </div>
    );
}

export default Separator;
